import { Stack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  InputSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { subscriptionCustomerListTableHead } from '../../SubscriptionCustomerListHeader/constants';

export const SubscriptionCustomerListItemLoadingDesktop: React.FC = () => {
  const getFlex = (index: number) => {
    const currentHead = subscriptionCustomerListTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <LateralBar
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <Stack pr="inline.xxxs">
          <InputSkeleton />
        </Stack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TextSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
